import { FC, useEffect, useState } from 'react';

interface AnimatedBirdIconProps {
  className?: string;
}

export const AnimatedBirdIcon: FC<AnimatedBirdIconProps> = ({ className }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    const flipInterval = setInterval(() => {
      setIsFlipped(prev => !prev);
    }, 3000);

    return () => clearInterval(flipInterval);
  }, []);

  return (
    <svg 
      width="65" 
      height="64" 
      viewBox="0 0 65 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} ${isFlipped ? 'scale-x-[-1]' : ''} transition-transform duration-1000`}
    >
      <path d="M43.1667 18.6666H43.1934" stroke="currentColor" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.56659 47.9995H32.4999C38.1579 47.9995 43.5841 45.7519 47.5849 41.7511C51.5856 37.7503 53.8332 32.3241 53.8332 26.6662V18.6662C53.8393 16.3939 53.1195 14.1791 51.7788 12.3445C50.4382 10.5099 48.5467 9.15138 46.38 8.46685C44.2133 7.78232 41.8847 7.80758 39.7333 8.53895C37.582 9.27032 35.7205 10.6696 34.4199 12.5328L5.83325 53.3328" stroke="currentColor" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M53.8333 18.6666L59.1666 20L53.8333 21.3333" stroke="currentColor" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M27.1667 48V56" stroke="currentColor" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M37.8333 47.3334V56" stroke="currentColor" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.1667 48.0004C22.4551 48.0002 25.6635 46.9869 28.3554 45.0983C31.0472 43.2097 33.0918 40.5375 34.2109 37.4455C35.33 34.3534 35.4692 30.9917 34.6096 27.8177C33.75 24.6437 31.9333 21.8117 29.4067 19.707" stroke="currentColor" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}; 